import { EventDrivenDemo } from './EventDrivenDemo'
import { GoalDrivenDemo } from './GoalDrivenDemo'
import { ExplainabilityDemo } from './ExplainabilityDemo'
import { DocumentDrivenDemo } from './DocumentDrivenDemo'
import { QuestionGroundedDemo } from './QuestionGroundedDemo'
import { ChangePropagationDemo } from './ChangePropagationDemo'
import { RiskScoringDemo } from './RiskScoringDemo'
import { WhatIfDemo } from './WhatIfDemo'
import { ContinuousAuditDemo } from './ContinuousAuditDemo'
import { MultiAgentDemo } from './MultiAgentDemo'
import type { LabDemoProps } from './types'

/**
 * Registry mapping paradigm id → demo component.
 *
 * Implementation roadmap:
 *   Phase B ✓ →  event-driven, goal-driven, explainability
 *   Phase C ✓ →  document-driven, question-grounded, change-propagation, risk-scoring
 *   Phase D ✓ →  what-if, continuous-audit, multi-agent
 */
export const LAB_REGISTRY: Record<string, React.FC<LabDemoProps>> = {
  'event-driven': EventDrivenDemo,
  'document-driven': DocumentDrivenDemo,
  'question-grounded': QuestionGroundedDemo,
  'goal-driven': GoalDrivenDemo,
  'change-propagation': ChangePropagationDemo,
  'what-if': WhatIfDemo,
  'continuous-audit': ContinuousAuditDemo,
  'multi-agent': MultiAgentDemo,
  'risk-scoring': RiskScoringDemo,
  'explainability': ExplainabilityDemo,
}
